import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import linkedin from '../assets/icons/social/linkedin-white.svg';
import instagram from '../assets/icons/social/instagram-white.svg';
import youtube from '../assets/icons/social/youtube-white.svg';

import { colors, Container, InternalLink, media, Text } from '../ui-components';

/**
 * @component GlobalPageFooter
 * 
 * @return {JSX}
 */
const GlobalPageFooter = () => {
  return (
    <GlobalFooterWrapper full>
      <LinkContainer>
        <a href="https://www.linkedin.com/company/credera" target="_blank" rel="noreferrer" title="LinkedIn">
          <SocialIcon src={linkedin} alt="LinkedIn logo" />
        </a>
        <a href="https://www.instagram.com/lifeatcredera/" target="_blank" rel="noreferrer" title="Instagram">
          <SocialIcon src={instagram} alt="Instagram logo" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCVgjc8oEkegCR2J6Lo0V62A"
          target="_blank"
          rel="noreferrer"
          title="Youtube"
        >
          <SocialIcon src={youtube} alt="Youtube logo" />
        </a>
        <Text>{'|'}</Text>
        <FooterInternalLink to="/cookie-notice">{'Cookie Settings'}</FooterInternalLink>
      </LinkContainer>
      <StyledText>{'|'}</StyledText>
      <Text>Copyright &copy; {moment().year()} Credera. All rights reserved.</Text>
    </GlobalFooterWrapper>
  );
};

export default GlobalPageFooter;

const GlobalFooterWrapper = styled(Container)`
  margin: 0;
  background-color: ${colors.footerBackground};
  display: flex;
  padding: 12px 80px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-width: 375px;

  p {
    color: ${colors.pureWhite};
  }

  @media screen and (max-width: ${media.mediumBottom}) {
    padding: 12px 20px;
    flex-direction: column;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: ${media.mediumBottom}) {
    gap: 16px;
  }
`;

const StyledText = styled(Text)`
  @media screen and (max-width: ${media.mediumBottom}) {
    display: none;
  }
`;

const SocialIcon = styled.img`
  margin: 0;
  width: 20px;
  height: 20px;
`;

const FooterInternalLink = styled(InternalLink)`
  font-weight: 400;
  text-transform: capitalize;
  color: ${colors.pureWhite};

  &:hover {
    color: ${colors.pureWhite};
    text-decoration: underline;
  }

  @media screen and (max-width: ${media.smallTop}) {
    line-height: 24px;
  }
`;
